import axios from '@/utils/request';

// 获取车辆列表
export const getCarList = (data) => {
    console.log(data)
    return axios.get('/system/car/getCarList', {params:data})
}

//获取获取车辆类型
export const getCarType = (data) => {
    return axios.get('/system/car/getCarTypeList', data) 
}

//获取车辆详情
export const getCarDetail = (data) => {
    return axios.get(`/system/car/getCarInfo/${data.id}`, data)
}

//获取车辆详情订单数据
export const getCarOrder = (data) => {
    return axios.get(`/system/order/getOrderList`, {params:data})  
}

//获取车辆详情预警数据
export const getCarWarning = (data) => {
    return axios.get(`/system/warn/getCarWarnList`, {params:data})
}

//获取车辆详情行程轨迹
export const getCarTrack = (data) => {
    return axios.get(`/system/car/getCarTravel`, {params:data}) 
}

//获取车辆详情实时视频
export const getCarVideo = (data) => {
    return axios.get(`/system/car/getRealVideo/${data.id}`)  
}

// 获取车辆预警详情
export const getDetail = (params) => {
    console.log(params)
    return axios.get('/system/warn/getCarWarnInfo', {params})
}

// 获取订单详情
export const getOrderInfo = (id) => {
    return axios.get(`/system/order/getOrderInfo/${id}`)
}


// 获取订单行程轨迹
export const getOrderTravel = (params) => {
    return axios.get(`/system/order/getOrderTravel`, { params })
}

// 获取订单监控
export const getOrderMonitoring = (params) => {
    return axios.get(`/system/order/getOrderMonitoring`, { params })
}
// 通知后端开始获取视频流
export const playDetection = (id) => {
    return axios.get(`/system/car/playDetection/${id}`)
}

// 通知后端开始关闭视频流
export const closeRealVideo = (id) => {
    return axios.get(`/system/car/closeRealVideo/${id}`)
}
